<ng-container *ngIf="user$ | async">
  <div
    *ngIf="(percentage$ | async) || (percentage$ | async) === 0"
    class="monthly-working-hours"
    [class.overworked]="((percentage$ | async) || 0) > 100"
    [style.--percentage]="percentage$ | async"
    [matTooltip]="tooltip || ''"
    matTooltipPosition="above">
    <div class="percentage-clock-wrapper">
      <div class="percentage-clock"></div>
    </div>
    <div class="percentage-number">{{ percentage$ | async }}%</div>
  </div>
</ng-container>
